/* global window */

// Parse a query string into an object
export function parseQueryString(str: string): any {
  if (!str) {
    return {};
  }
  const segments = str.split("&").map((s) => s.split("="));
  const queryString = {};
  segments.forEach((s) => (queryString[s[0]] = decodeURIComponent(s[1])));
  return queryString;
}

export function parseJwt(token): any {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}
